import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { useQuery } from 'react-query'
import { articlesKeys } from '../articlesKeys'
import { Access, SettingsMember } from 'types'

interface Props {
  articleKey: string
  permission?: Access[] | null
}

interface Params {
  permission?: string
}

const optionDefaults = {
  refetchOnWindowFocus: false,
}

export const useArticleUsers = ({ articleKey, permission = null }: Props, options = {}) => {
  return useQuery(articlesKeys.users(articleKey, { permission }), () => fetchArticleUsers(articleKey, permission), {
    ...optionDefaults,
    ...options,
  })
}

export const fetchArticleUsers = async (articleKey: string, permission: Props['permission']) => {
  const params: Params = {}
  if (permission && permission.length > 0) {
    params['permission'] = permission.join(',')
  }
  const res = await sendToApi<{ users: SettingsMember[] }>(`/articles/${articleKey}/users`, { params })
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw res.data
  }
  return res.data.users
}
